import { gsmIotDeviceSubscriptionHistory, extendedServerToken } from "../constants/apis";
import axios from "axios";

const getIotConfig = () => ({
    headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${extendedServerToken}`,
    },
});

export const getIotDevices = async (searchQuery = "", page = 1) => {
    const response = await axios.get(gsmIotDeviceSubscriptionHistory, {
        ...getIotConfig(),
        params: {
            search: searchQuery || undefined,
            page: page
        },
    });
    return response;
};